import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import { FaEdit, FaTrash, FaBan, FaEye, FaSync, FaCopy, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { colorStatus } from "./helper/polizaHelper";
import { duplicatePoliza } from "./form/actions/PolizaActions";
import * as moment from "moment";
import "./poliza.scss";

var ListPoliza = function ListPoliza(props) {
  var polizas = props.polizas,
      onSelectedPoliza = props.onSelectedPoliza,
      admin = props.admin,
      token = props.token,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      onSort = props.onSort;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      copyingId = _React$useState2[0],
      setCopyingId = _React$useState2[1]; // Hook para detectar el tamaño de la pantalla


  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isSmallScreen = _React$useState4[0],
      setIsSmallScreen = _React$useState4[1];

  React.useEffect(function () {
    var checkScreenSize = function checkScreenSize() {
      setIsSmallScreen(window.innerWidth <= 800);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return function () {
      return window.removeEventListener('resize', checkScreenSize);
    };
  }, []); // Mapeo de columnas a campos de Elasticsearch

  var columnFieldMap = {
    "Propuesta": "id",
    "Nº Póliza": "code.keyword",
    "Estado": "status_name.keyword",
    "End": "poliza_endorsements_count",
    "Compañía": "company.name.keyword",
    "Asegurado": "asegurado.full_name.keyword",
    "Materia": "materia_asegurada_formatted.keyword",
    "Inicio Vigencia": "start_date",
    "Fin Vigencia": "finish_date",
    "Ramo": "ramo.keyword",
    "Prima Total": "prima_neta",
    "Forma de pago": "tipo_de_pago.keyword",
    "Fecha de envío Póliza": "sent_at",
    "Acciones": "" // No ordenable

  };

  var getSortIcon = function getSortIcon(columnName) {
    var field = columnFieldMap[columnName];

    if (!field || !sortField || sortField !== field) {
      return /*#__PURE__*/React.createElement(FaSort, {
        style: {
          marginLeft: "4px",
          opacity: 0.4,
          fontSize: "12px"
        }
      });
    }

    return sortOrder === "asc" ? /*#__PURE__*/React.createElement(FaSortUp, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    }) : /*#__PURE__*/React.createElement(FaSortDown, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    });
  };

  var handleHeaderClick = function handleHeaderClick(columnName, event) {
    event.preventDefault();
    event.stopPropagation();
    var field = columnFieldMap[columnName];

    if (field && onSort) {
      onSort(field);
    }
  }; // Función helper para estilos de celdas que permiten múltiples líneas


  var getCellStyle = function getCellStyle(width) {
    var additionalStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread({
      width: isSmallScreen ? "auto" : width,
      padding: isSmallScreen ? "8px 4px" : "4px 8px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal"
    }, additionalStyles);
  }; // Función helper para estilos de encabezados


  var getHeaderStyle = function getHeaderStyle(width) {
    return {
      width: isSmallScreen ? "auto" : width,
      cursor: "pointer",
      userSelect: "none",
      whiteSpace: "normal",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      padding: isSmallScreen ? "8px 4px" : undefined
    };
  }; // Estado para el tooltip de scroll


  var _React$useState5 = React.useState({
    show: false,
    text: "",
    x: 0,
    y: 0
  }),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      scrollTooltip = _React$useState6[0],
      setScrollTooltip = _React$useState6[1]; // Ref para la tabla y el contenedor scrollable


  var tableRef = React.useRef(null);
  var scrollRef = React.useRef(null);
  var scrollTimeout = React.useRef(null); // Nombres de las columnas para el tooltip

  var columnNames = ["Propuesta", "Nº Póliza", "Estado", "End", "Compañía", "Asegurado", "Materia", "Inicio Vigencia", "Fin Vigencia", "Ramo", "Prima Total", "Forma de pago", "Fecha de envío Póliza", "Acciones"]; // Función para manejar el scroll y mostrar tooltip

  var handleScroll = function handleScroll(event) {
    if (!tableRef.current || !scrollRef.current) return;
    var ths = tableRef.current.querySelectorAll('thead th');
    if (!ths.length) return;
    var scrollLeft = scrollRef.current.scrollLeft;
    var clientWidth = scrollRef.current.clientWidth; // Encontrar la columna que está en el centro del viewport

    var viewportCenter = scrollLeft + clientWidth / 2;
    var closestColumn = 0;
    var minDistance = Infinity;
    ths.forEach(function (th, idx) {
      var thElement = th;
      var thLeft = thElement.offsetLeft;
      var thWidth = thElement.offsetWidth;
      var thCenter = thLeft + thWidth / 2;
      var distance = Math.abs(thCenter - viewportCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestColumn = idx;
      }
    }); // Posicionar el tooltip justo encima de la barra de scroll

    var scrollRect = scrollRef.current.getBoundingClientRect();
    var scrollbarY = scrollRect.bottom - 20; // 20px arriba de la barra
    // Calcular posición X basada en la columna más cercana al centro

    var thElement = ths[closestColumn];
    var thLeft = thElement.offsetLeft;
    var thWidth = thElement.offsetWidth;
    var thCenter = thLeft + thWidth / 2; // Ajustar la posición X para que esté centrada en la columna

    var adjustedX = scrollRect.left + (thCenter - scrollLeft); // Solo mostrar tooltip si hay scroll horizontal

    if (scrollLeft > 0 || scrollRef.current.scrollWidth > scrollRef.current.clientWidth) {
      setScrollTooltip({
        show: true,
        text: "Columna: ".concat(columnNames[closestColumn]),
        x: adjustedX,
        y: scrollbarY
      });
    }
  }; // Función para ocultar tooltip cuando se suelta el scroll


  var handleScrollEnd = function handleScrollEnd() {
    setScrollTooltip(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        show: false
      });
    });
  }; // Función para manejar cuando se suelta el mouse o el touch


  var handleMouseUp = function handleMouseUp() {
    handleScrollEnd();
  };

  var handleTouchEnd = function handleTouchEnd() {
    handleScrollEnd();
  }; // Función para manejar cuando se mueve el mouse sobre la barra de scroll


  var handleMouseMove = function handleMouseMove(event) {
    if (!scrollRef.current) return;
    var rect = scrollRef.current.getBoundingClientRect();
    var mouseY = event.clientY; // Solo mostrar tooltip si el mouse está cerca de la barra de scroll

    if (mouseY >= rect.bottom - 30) {
      handleScroll(event);
    } else {
      handleScrollEnd();
    }
  };
  /* poliza.status PUEDEN SER => "BORRADOR" , "VIGENTE", "NO VIGENTE"
  poliza.sub_status PUEDEN SER => "NUEVA", "POR RENOVAR" ..... */


  if (polizas && polizas.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "table-responsive",
      style: {
        overflowX: "auto",
        overflowY: "visible",
        width: "100%",
        position: "relative",
        WebkitOverflowScrolling: "touch"
      },
      ref: scrollRef,
      onScroll: handleScroll,
      onMouseUp: handleMouseUp,
      onTouchEnd: handleTouchEnd,
      onMouseMove: handleMouseMove
    }, /*#__PURE__*/React.createElement("table", {
      ref: tableRef,
      className: "table table-striped table-sm table-bordered cntListPoliza",
      "data-toggle": "table",
      style: {
        width: "100%",
        minWidth: isSmallScreen ? "100%" : "1400px",
        tableLayout: isSmallScreen ? "auto" : "fixed"
      }
    }, /*#__PURE__*/React.createElement("thead", {
      className: "tableHeader"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Propuesta", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Propuesta", getSortIcon("Propuesta"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: getHeaderStyle("10%"),
      onClick: function onClick(e) {
        return handleHeaderClick("Nº Póliza", e);
      },
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "N\xBA P\xF3liza", getSortIcon("Nº Póliza"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: getHeaderStyle("10%"),
      onClick: function onClick(e) {
        return handleHeaderClick("Estado", e);
      },
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Estado", getSortIcon("Estado"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("End", e);
      },
      style: getHeaderStyle("3%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "End", getSortIcon("End"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Compañía", e);
      },
      style: getHeaderStyle("9%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Compa\xF1\xEDa", getSortIcon("Compañía"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Asegurado", e);
      },
      style: getHeaderStyle("9%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Asegurado", getSortIcon("Asegurado"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Materia", e);
      },
      style: getHeaderStyle("9%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Materia", getSortIcon("Materia"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Inicio Vigencia", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Inicio Vigencia", getSortIcon("Inicio Vigencia"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Fin Vigencia", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Fin Vigencia", getSortIcon("Fin Vigencia"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Ramo", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Ramo", getSortIcon("Ramo"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Prima Total", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Prima Total", getSortIcon("Prima Total"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Forma de pago", e);
      },
      style: getHeaderStyle("7%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Forma de pago", getSortIcon("Forma de pago"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: getHeaderStyle("6%"),
      onClick: function onClick(e) {
        return handleHeaderClick("Fecha de envío Póliza", e);
      },
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Fecha de env\xEDo P\xF3liza", getSortIcon("Fecha de envío Póliza"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: getHeaderStyle("9%")
    }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
      className: "tableBody"
    }, polizas && polizas.map(function (poliza) {
      return /*#__PURE__*/React.createElement("tr", {
        key: poliza.id
      }, /*#__PURE__*/React.createElement("th", {
        scope: "row",
        style: getCellStyle("8%")
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexWrap: isSmallScreen ? "wrap" : "nowrap"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id),
        className: "btn btn-info btn-xs",
        title: "Ver detalles",
        style: {
          padding: "2px 4px",
          fontSize: "10px"
        }
      }, /*#__PURE__*/React.createElement(FaEye, null)), /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id)
      }, poliza.id))), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("10%", {
          textAlign: "center"
        })
      }, /*#__PURE__*/React.createElement("a", {
        href: "#polizaModal",
        "data-toggle": "modal",
        "data-target": "#polizaModal",
        onClick: function onClick() {
          return onSelectedPoliza && onSelectedPoliza(poliza);
        },
        style: {
          fontSize: "13px",
          fontWeight: "600",
          color: "#2596be",
          textDecoration: "none",
          letterSpacing: "0.5px"
        },
        title: "Ver detalles de la p\xF3liza"
      }, poliza.code ? poliza.code : "Ver")), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("10%")
      }, colorStatus(poliza.status_name), " ", poliza.status_name, poliza.substatus_name ? " - ".concat(poliza.substatus_name) : ""), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("3%", {
          textAlign: "center"
        })
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/poliza_endorsements"),
        target: "_blank"
      }, poliza.poliza_endorsements_count || 0)), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("9%")
      }, poliza.company ? poliza.company.name : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("9%")
      }, poliza.asegurado ? "".concat(poliza.asegurado.full_name, " ").concat(formatRut(poliza.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("9%")
      }, poliza !== null && poliza !== void 0 && poliza.item_asegurados ? poliza.materia_asegurada_formatted : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, poliza.start_date ? moment(poliza.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, poliza.finish_date ? moment(poliza.finish_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("8%")
      }, poliza.ramo ? poliza.ramo : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, poliza.currency, " ", poliza.prima_neta ? poliza.prima_neta : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("7%")
      }, poliza.tipo_de_pago ? poliza.tipo_de_pago : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, poliza.sent_at ? moment(poliza.sent_at).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: {
          width: "9%",
          padding: "3px 5px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "3px",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "3px",
          justifyContent: "center"
        }
      }, (admin.is_super_admin || admin.permissions_code.includes("poliza_edit")) && /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/edit"),
        className: "btn btn-primary btn-xs",
        title: "Editar",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaEdit, null)), token && (admin.is_super_admin || admin.permissions_code.includes("poliza_edit")) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-xs",
        title: "Copiar propuesta",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        },
        disabled: copyingId === poliza.id,
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _result$payload;

          var result, _result$payload2;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setCopyingId(poliza.id);
                  _context.next = 3;
                  return duplicatePoliza(poliza.id, token);

                case 3:
                  result = _context.sent;
                  setCopyingId(null);

                  if (result.status === "ok" && (_result$payload = result.payload) !== null && _result$payload !== void 0 && _result$payload.id) {
                    window.open("/admin/polizas/".concat(result.payload.id, "/edit"), "_blank");
                  } else {
                    alert(((_result$payload2 = result.payload) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.message) || "Error al copiar la propuesta");
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      }, /*#__PURE__*/React.createElement(FaCopy, null)), /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/renew"),
        className: "btn btn-primary btn-xs",
        title: "Renovar",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaSync, null))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "3px",
          justifyContent: "center"
        }
      }, (admin.is_super_admin || admin.permissions_code.includes("poliza_cancel")) && /*#__PURE__*/React.createElement("a", {
        href: "/api/v1/polizas/".concat(poliza.id, "/cancel"),
        className: "btn btn-danger btn-xs",
        "data-method": "delete",
        rel: "nofollow",
        "data-confirm": "\xBFEst\xE1s seguro de CANCELAR la p\xF3liza ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code, "?"),
        title: "Cancelar",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaBan, null)), (admin.is_super_admin || admin.permissions_code.includes("poliza_destroy")) && /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id),
        className: "btn btn-danger btn-xs",
        "data-confirm": "Est\xE1s seguro de ELIMINAR la p\xF3liza ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code, "?"),
        rel: "nofollow",
        "data-method": "delete",
        title: "Eliminar",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaTrash, null))))));
    }))), scrollTooltip.show && /*#__PURE__*/React.createElement("div", {
      className: "scroll-tooltip",
      style: {
        left: scrollTooltip.x,
        top: scrollTooltip.y
      }
    }, scrollTooltip.text));
  }

  return /*#__PURE__*/React.createElement("h3", null, "No se han encontrado P\xF3lizas.");
};

export default ListPoliza;